<template>
  <b-card no-body class="guest-checkout-card">
    <div class="guest-checkout-card__header">
      <span class="guest-checkout-card__eyebrow">Acceso rápido</span>
      <h4 class="guest-checkout-card__title mb-50">
        Revisa hoy y paga cuando estés listo
      </h4>
      <p class="guest-checkout-card__copy mb-0">
        Estás viendo tu cotización completa y no necesitas cuenta para revisarla.
        Para pagarla, subir tu comprobante o pedir factura, inicia sesión.
      </p>
    </div>

    <div class="guest-checkout-card__body">
      <div class="guest-checkout-card__benefits">
        <div class="guest-checkout-card__benefit">
          <feather-icon icon="ShieldIcon" size="16" />
          <span>Acceso seguro con tu usuario</span>
        </div>
        <div class="guest-checkout-card__benefit">
          <feather-icon icon="CreditCardIcon" size="16" />
          <span>Paga y factura desde la misma cotización</span>
        </div>
      </div>

      <b-button
        variant="primary"
        class="guest-checkout-card__primary"
        block
        @click="goToLogin"
      >
        Iniciar sesión para continuar
      </b-button>

      <b-button
        variant="outline-secondary"
        block
        @click="printInvoice"
      >
        {{ $t('print') }}
      </b-button>
    </div>
  </b-card>
</template>

<script>
import { BCard, BButton } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BButton,
  },
  methods: {
    goToLogin() {
      localStorage.setItem('redirectAfterLogin', this.$route.fullPath)
      this.$router.push({ name: 'auth-login' })
    },
    printInvoice() {
      window.print()
    },
  },
}
</script>

<style scoped>
.guest-checkout-card {
  overflow: hidden;
  border: 1px solid rgba(92, 75, 135, 0.12);
  border-radius: 22px;
  box-shadow: 0 20px 40px rgba(53, 43, 89, 0.08);
}

.guest-checkout-card__header {
  padding: 1.25rem 1.25rem 1rem;
  background: linear-gradient(180deg, rgba(52, 6, 104, 0.08) 0%, rgba(52, 6, 104, 0.03) 100%);
}

.guest-checkout-card__eyebrow {
  display: inline-block;
  margin-bottom: 0.55rem;
  color: #5b22a6;
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.guest-checkout-card__title {
  color: #322b45;
  font-weight: 800;
}

.guest-checkout-card__copy {
  color: #6f6785;
  line-height: 1.55;
}

.guest-checkout-card__body {
  padding: 1.15rem 1.25rem 1.25rem;
}

.guest-checkout-card__benefits {
  display: grid;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.guest-checkout-card__benefit {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  color: #5f5973;
  font-weight: 600;
}

.guest-checkout-card__primary {
  margin-bottom: 0.75rem;
}
</style>
